import { Button, ButtonContainer, Card, ContentSection, Layout } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CustomerTypeSelectionForm } from '../../../components/CustomerTypeSelectionForm/CustomerTypeSelectionForm';
import { ProductFamilySelectionForm } from '../../../components/ProductFamilySelectionForm/ProductFamilySelectionForm';
import { VehicleTypeSelectForm } from '../../../components/VehicleTypeSelectForm/VehicleTypeSelectForm';
import { journeyDataSelectors } from '../../../services/redux/features/journeyData.slice';
import { useNavigate } from '../../../services/routing';
import { WizardPagesEnum } from '../newQuotation.slice';
import { resetQuoteSpecificReduxData } from '../../../services/redux';

export const QuoteTypeSelectionPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const productFamily = useSelector(journeyDataSelectors.productFamily);
  const customerType = useSelector(journeyDataSelectors.customerType);
  const vehicleType = useSelector(journeyDataSelectors.vehicleType);

  useEffect(() => {
    resetQuoteSpecificReduxData();
  }, []);

  return (
    <>
      <ContentSection pageWrapSize="small">
        <Layout center>
          <Card title={t('customerTypeSelectionPage:formHeading')}>
            <CustomerTypeSelectionForm />
          </Card>

          {customerType && (
            <Card title={t('productFamilySelectionPage:header')}>
              <ProductFamilySelectionForm />
            </Card>
          )}

          {productFamily && customerType && (
            <Card title={t('vehicleTypeSelectPage:header')}>
              <VehicleTypeSelectForm />
            </Card>
          )}
        </Layout>
      </ContentSection>

      <ContentSection pageWrapSize="small">
        <Layout center>
          <Layout.Item>
            <ButtonContainer center>
              <Button
                type="button"
                testId="button_back"
                secondary
                onClick={() => {
                  navigate.dashboardHome();
                }}
              >
                {t('vehicleTypeSelectPage:navigation:cancel')}
              </Button>

              <Button
                testId="button_continue"
                disabled={!(customerType && productFamily && vehicleType)}
                onClick={() => {
                  if (vehicleType === 'used') {
                    navigate.newQuote(`/${WizardPagesEnum.usedCarPage}`);
                  } else {
                    navigate.newQuote(`/${WizardPagesEnum.newCarConfigurator}`);
                  }
                }}
              >
                {t('vehicleTypeSelectPage:navigation:continue')}
              </Button>
            </ButtonContainer>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
